__turbopack_context__.v({
  "container": "FooterLinks-module-scss-module__qGmB3W__container",
  "link": "FooterLinks-module-scss-module__qGmB3W__link",
  "links": "FooterLinks-module-scss-module__qGmB3W__links",
  "list": "FooterLinks-module-scss-module__qGmB3W__list",
  "rootItem": "FooterLinks-module-scss-module__qGmB3W__rootItem",
  "rootList": "FooterLinks-module-scss-module__qGmB3W__rootList",
  "title": "FooterLinks-module-scss-module__qGmB3W__title",
});
